import React, { memo } from 'react'
import { Modal } from '../modal'
import Alert from '../alert/alert'
import { Col, Row } from 'react-grid-system'
import Button from '../button/button'
import { Severity } from '../../../types'

import * as styles from './styles.module.scss'
import { DeleteModalProps } from './types'

const DeleteModal = ({
   isOpen,
   handleClose,
   title,
   content,
   snackbarState,
   handleDelete,
   isLoading,
}: DeleteModalProps) => (
   <Modal
      isModalVisible={isOpen}
      closeModal={handleClose}
      title={`Delete${title}`}
   >
      <div className={styles.content}>
         <p>{content}</p>

         {snackbarState.message &&
            snackbarState.severity === Severity.ERROR && (
               <Alert message={snackbarState.message} />
            )}

         <Row gutterWidth={20}>
            <Col xs={6}>
               <Button
                  minWidth="100%"
                  variant="danger"
                  onClick={handleDelete}
                  loading={isLoading}
               >
                  Delete
               </Button>
            </Col>
            <Col xs={6}>
               <Button
                  minWidth="100%"
                  variant="tertiary"
                  onClick={handleClose}
                  isReset
               >
                  Cancel
               </Button>
            </Col>
         </Row>
      </div>
   </Modal>
)

export default memo(DeleteModal)
